import React from "react";
import { motion } from "framer-motion";

import { Blocks, Bolt, Dog, Flame, Goal, Lock, RailSymbol, Rocket, Subtitles, Trash2 } from "lucide-react";

// Example card data (9 cards)
const cards = [
//   { status: "ACTIVE", title: "Koco Widgets - Minimal Design on the App Store", impressions: "83.5k", ctr: "4.26%", cpm: "$3.98", cpc: "$2.95" },
//   { status: "ACTIVE", title: "Exclusive Travel Deals from $299 Trip", impressions: "50.2k", ctr: "3.14%", cpm: "$4.22", cpc: "$3.10" },
//   { status: "ACTIVE", title: "Ergonomic Chairs Now 30% Off for a Limited Time", impressions: "90.1k", ctr: "5.01%", cpm: "$3.75", cpc: "$2.40" },
//   { status: "ACTIVE", title: "Try Our New Caramel Latte with Free Pastry", impressions: "61.5k", ctr: "4.02%", cpm: "$3.50", cpc: "$2.10" },
//   { status: "ACTIVE", title: "Jewelry Collection Launch with Free Gift Wrapping", impressions: "77.5k", ctr: "3.85%", cpm: "$4.00", cpc: "$3.00" },
  { status: "ACTIVE", title: "Premium Online Workout – 30 Day Challenge", impressions: "102k", ctr: "6.01%", cpm: "$3.20", cpc: "$1.95" },
  { status: "ACTIVE", title: "Framer Design Top Campaign", impressions: "58k", ctr: "3.52%", cpm: "$4.50", cpc: "$3.40" },
  { status: "ACTIVE", title: "Organic Snacks – Special Weekend Offer", impressions: "49k", ctr: "2.99%", cpm: "$3.40", cpc: "$2.05" },
  { status: "ACTIVE", title: "Home Decor Essentials – Trending Collection", impressions: "112k", ctr: "5.20%", cpm: "$3.10", cpc: "$1.75" },
];

export default function CardAnim2({id,mode}) {
  return (<>
   <div className={`ca2${id}-container`}>
      <div className={`ca2${id}-grid`}>
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className={`ca2${id}-card`}
            initial={{ opacity: 0, transform: "translateY(40px) scale(0.95)" }}
            animate={{ opacity: 1, transform: "translateY(0) scale(1)" }}
            transition={{ delay: index * 0.15, duration: 0.6, ease: "easeOut" }}
          >
            <div className={`ca2${id}-badge`}>{card.status}</div>
            <h3 className={`ca2-title`}>{card.title}</h3>
            <div className={`ca2${id}-info`}>
              <p><strong>Impressions:</strong> {card.impressions}</p>
              <p><strong>CTR:</strong> {card.ctr}</p>
              <p><strong>CPM:</strong> {card.cpm}</p>
              <p><strong>CPC:</strong> {card.cpc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

    <style>{`:root{
     --card-w${id}: 280px;
  --card-h${id}: 340px;
 --glass-bg${id}:${mode=="white"?"rgba(255,255,255,0.85)":"rgba(31, 29, 29, 0.85)"} ;
  --muted${id}: #6b7280;
  --accent${id}: #6b46ff;
}

/* Container centers the layout and shows small screenshot preview on left */
.ca2${id}-container{
  position:relative;min-height:400px;
  
  margin:0px auto;
  padding:30px;
  box-sizing:border-box;
  
}




.ca2${id}-card{
  width:var(--card-w${id});
  height:var(--card-h${id});
  padding:20px;
  box-sizing:border-box;
  border-radius:14px;
  background:var(--glass-bg${id});
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px);
  border:1px solid rgba(99,102,241,0.06);
  box-shadow: 0 8px 30px rgba(16,24,40,0.08);
  position:absolute;
  left:0;
  top:0;
  transform-origin: center;
  transition: transform 320ms cubic-bezier(.2,.9,.2,1), box-shadow 220ms;
  cursor:default;
 
}

.ca2${id}-card:hover{
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 18px 50px rgba(16,24,40,0.12);
  z-index: 999 !important;
}

.ca2${id}-badge{
  display:inline-block;
  padding:6px 10px;
  border-radius:8px;
  font-size:12px;
  font-weight:700;
  color:#065f46; /* green */
  background: rgba(16,185,129,0.08);
  width:fit-content;
  margin-bottom:12px;
}

.ca2-title{
  font-size:16px;
  line-height:1.25;
  margin:0 0 12px 0;
  color:${mode=="white"?"rgba(31, 29, 29, 0.85)":"rgba(255,255,255,0.85)"} !important;
  font-weight:700;
}

.ca2${id}-info{
  margin-top:auto;
  font-size:13px;
  color:var(--muted${id});
}

.ca2${id}-info p{margin:6px 0}

/* Create staggered stacked layout by targeting nth-child positions */
.ca2${id}-grid .ca2${id}-card:nth-child(1){  z-index:1 }
.ca2${id}-grid .ca2${id}-card:nth-child(2){  z-index:2 }
.ca2${id}-grid .ca2${id}-card:nth-child(3){  z-index:3 }
.ca2${id}-grid .ca2${id}-card:nth-child(4){  z-index:4 }
.ca2${id}-grid .ca2${id}-card:nth-child(5){ z-index:5 }
.ca2${id}-grid .ca2${id}-card:nth-child(6){  z-index:6 }
.ca2${id}-grid .ca2${id}-card:nth-child(7){  z-index:7 }
.ca2${id}-grid .ca2${id}-card:nth-child(8){  z-index:8 }
.ca2${id}-grid .ca2${id}-card:nth-child(9){  z-index:9 }

/* subtle float-ca2${id}ing animation for each card (different durations for organic feel) */
@keyframes float-ca2${id}A{ 0%{ transform: rotate(-40deg) scale(0.6); z-index:9; }50%{ transform: translateY(-106px) ; rotate(-11deg) scale(0.8);}100%{ transform:  rotate(-40deg) scale(0.6); z-index:1;  }}
@keyframes float-ca2${id}B{ 0%{  transform: translate(0px, -30px) rotate(-10deg) scale(0.6); z-index:9; }50%{ transform: translateY(-100px); translate(120px, -30px) rotate(-11deg) scale(0.8); }100%{  transform:  translate(0px, -30px) rotate(-10deg) scale(0.6); z-index:1;  }}

.ca2${id}-grid .ca2${id}-card:nth-child(1){ animation: float-ca2${id}A 6s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(2){ animation: float-ca2${id}A 7s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(3){ animation: float-ca2${id}A 8s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(4){ animation: float-ca2${id}A 9s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(5){ animation: float-ca2${id}A 10s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(6){ animation: float-ca2${id}A 11s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(7){ animation: float-ca2${id}A 12s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(8){ animation: float-ca2${id}A 13s ease-in-out infinite; }
.ca2${id}-grid .ca2${id}-card:nth-child(9){ animation: float-ca2${id}A 14s ease-in-out infinite; }

`}</style>
 </> );
}
